import React, { useState } from 'react';
import './PartnerFaq.css';

const faqData = [
  {
    question: "What is ABOMED?",
    answer: `Abomed is a digital healthcare platform designed to simplify and modernize access to essential medical services. We connect users with trusted pharmacies, Pathology labs, Diagnostic imaging centers, and blood banks—ensuring fast, reliable, and transparent healthcare delivery right at their fingertips. Our mission is to bridge the gap between healthcare providers and patients through technology, trust, and accessibility.`
  },
  {
    question: "What is Abomed Marketing Partners?",
    answer: `Abomed Marketing Partners are individuals who help us onboard local healthcare vendors—like pharmacies, pathology labs, diagnostic scan centers, and blood banks—onto the Abomed partner platform. It's a field and digital outreach program that lets you earn, learn, and grow, while helping improve healthcare access in your area.`
  },
  {
    question: "Why should I join Abomed as a Marketing Partner?",
    list: [
      "Receive up to 50% of Abomed's profit from every vendor you onboard",
      "No investment or experience needed",
      "Work on-ground or digitally",
      "Monthly income + certificate + long-term growth",
      "Become a revenue-sharing partner in the future of healthcare"
    ]
  },
  {
    question: "How much can I earn as an Abomed Marketing Partner?",
    answer: `You can earn up to 50% of the profit Abomed makes from each vendor you onboard. Payments are monthly for 2 years.`,
    list: [
      "If you onboard 100 vendors and each generates ₹10,000/month in profit:",
      "Abomed earns ₹10,00,000",
      "You earn up to ₹5,00,000 per month"
    ]
  },
  {
    question: "How will I receive my payment/profit as a Marketing Partner?",
    answer: `Payouts are monthly and transferred directly to your bank account. You'll receive detailed performance reports, ensuring transparency and timely payments.`
  },
  {
    question: "Who can become a Marketing Partner at Abomed?",
    list: [
      "Anyone: student, fresher, job-seeker, professional",
      "No experience or investment required",
      "Open to all cities in India"
    ]
  },
  {
    question: "How does the Abomed Marketing Partner program work?",
    list: [
      "Onboard local vendors (pharmacy, labs, scan centers, blood banks)",
      "Vendors get listed and promoted on Abomed",
      "You earn up to 50% of Abomed's profit from their sales"
    ]
  },
  {
    question: "How are vendors verified?",
    list: [
      "Check business license, GST, contact & address",
      "Ensure service quality standards"
    ]
  },
  {
    question: "Is there any joining fee or investment required?",
    answer: "No. Joining is completely free. No deposits or hidden charges."
  },
  {
    question: "What are the responsibilities of an Abomed Marketing Partner?",
    list: [
      "Identify and approach vendors",
      "Explain Abomed’s benefits and assist onboarding",
      "Ensure successful listing"
    ]
  },
  {
    question: "Whom do I contact if I face any issue?",
    answer: `Email: support@abomed.in`
  },
  {
    question: "Is there a minimum number of vendors required to start receiving payments?",
    answer: `No minimum required. Even one vendor qualifies you for earnings.`
  },
  {
    question: "How long does it take to verify a vendor?",
    answer: `Usually 2–5 working days after all required documents are received.`
  },
  {
    question: "How can I track my earnings?",
    answer: `Monthly performance reports will be shared. A dashboard is coming soon.`
  },
  {
    question: "Do I get paid for unverified or inactive vendors?",
    answer: `No. Earnings are only for verified and active vendors generating sales.`
  },
  {
    question: "Which vendors can I onboard as a Marketing Partner?",
    list: [
      "Pharmacies / Medical Stores",
      "Pathology Labs",
      "Diagnostic Imaging & Scan Centers",
      "Blood Banks"
    ]
  },
  {
    question: "How do I help a vendor register on Abomed?",
    answer: `Explain Abomed’s benefits. Help them download the Partner App and register. Make sure they select "Abomed Marketing Partner" and enter your ID to link earnings. Our team handles the rest.`
  }
];

const PartnerFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1>Abomed Marketing Partner - FAQ</h1>
      {faqData.map((faq, index) => (
        <div
          className={`faq-card ${openIndex === index ? 'open' : ''}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleIndex(index)}>
            {faq.question}
            <span className="arrow">{openIndex === index ? '−' : '+'}</span>
          </div>
          {openIndex === index && (
            <div className="faq-answer">
              {faq.answer && <p>{faq.answer}</p>}
              {faq.list && (
                <ul>
                  {faq.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PartnerFAQ;